module.exports = __webpack_public_path__ + "img/userB07.2d37626b.jpg";